import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '~/utils/eventbus';

@Component({})
export default class ConfirmDeleteModalComponent extends Vue {
    private selectedDeleteBr: boolean = false;

    constructor() {
        super();
    }

    private deleteBr() {
        this.selectedDeleteBr = true;
        this.$emit('deletebudget', this.selectedDeleteBr);
        EventBus.$emit(EventBus.DELETE_BUDGET_REQUEST.DELETE_MODAL, this.selectedDeleteBr);
    }

    private onClickButton() {
        this.$emit('clickedcanceleditstate', false);
    }
}
